// src/pages/academic/academicConstants.js

export const ACADEMIC_ROOT = "/dashboard/academic";

// نفس القيم الموجودة في AcademicSkill.skill_type (الباك إند بيقبل MIXED كمان)
export const SKILL_TYPE_LABELS = {
  VOCABULARY: { label: "Vocabulary", color: "bg-blue-100 text-blue-700" },
  GRAMMAR: { label: "Grammar", color: "bg-purple-100 text-purple-700" },
  READING: { label: "Reading", color: "bg-amber-100 text-amber-700" },
  LISTENING: { label: "Listening", color: "bg-cyan-100 text-cyan-700" },
  SPEAKING: { label: "Speaking", color: "bg-orange-100 text-orange-700" },
  WRITING: { label: "Writing", color: "bg-pink-100 text-pink-700" },
  MIXED: { label: "Mixed", color: "bg-slate-100 text-slate-700" },
};

export const SKILL_TYPE_OPTIONS = Object.entries(SKILL_TYPE_LABELS).map(
  ([value, { label }]) => ({ value, label })
);

// ⚠️ راجع القيم دي مع choices الحقل question_order_type في AcademicSkill (models.py بتاع academic).
// لو اخترت قيمة غلط الباك إند هيرجّع 400. لو سبت الاختيار "Default" مش بيتبعت وبيستخدم default الموديل.
export const QUESTION_ORDER_OPTIONS = [
  { value: "", label: "Default" },
  { value: "ORDERED", label: "Ordered" },
  { value: "RANDOM", label: "Random" },
];